import { ChiroUpAPI } from '@chiroup/client-core/functions/ChiroUpAPI';

const userService = () => {
  const login = async ({
    path,
    dateOfBirth,
    email,
    phone,
  }: {
    path: string;
    dateOfBirth: string;
    email?: string;
    phone?: string;
  }): Promise<any> => {
    return ChiroUpAPI.post('api-noauth', `/login`, {
      body: {
        path,
        email,
        phone,
        dateOfBirth,
      },
    });
  };

  const me = async (path?: string): Promise<any> => {
    if (!path) return null;

    return ChiroUpAPI.get('api', `/me/${path}`, {});
  };

  return {
    login,
    me,
  };
};

export default userService();
